import { render, staticRenderFns } from "./PatrolsView.vue?vue&type=template&id=dd8f52f2&scoped=true&"
import script from "./PatrolsView.vue?vue&type=script&lang=js&"
export * from "./PatrolsView.vue?vue&type=script&lang=js&"
import style0 from "./PatrolsView.vue?vue&type=style&index=0&id=dd8f52f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8f52f2",
  null
  
)

export default component.exports